<div (keyup.enter)="Save()">
  @if(Auftrag?.ruekholung; as ruek)
  {
  <div class="row">
    <div class="col">
      <Date-Select LabelText="Beauftragt" [(Date)]="ruek.beauftragt" [MinDate]="Auftrag?.versand?.paketVersand" [enabeld]="ApiUser.HatSpezialUserBerechtigung"></Date-Select>
    </div>
  </div>
  @if(ShowIfIsNotNull(ruek.beauftragt))
  {
  <div class="row">
    <div class="col">
      <Date-Select LabelText="Eingefordert" [(Date)]="ruek.eingefordert" [MinDate]="Auftrag?.versand?.paketVersand" [enabeld]="ApiUser.HatSpezialUserBerechtigung"></Date-Select>
    </div>
  </div>
  }
  @if(ShowIfIsNotNull(ruek.eingefordert))
  {
  <div class="row">
    <div class="col">
      <Date-Select LabelText="Leitstelle Abgemeldet" [(Date)]="ruek.asbAbgemeldet" [MinDate]="Auftrag?.versand?.paketVersand" [enabeld]="ApiUser.HatSpezialUserBerechtigung"></Date-Select>
    </div>
  </div>
  }
  @if(ShowIfIsNotNull(ruek.asbAbgemeldet))
  {
  <div class="row">
    <div class="col">
      <Date-Select LabelText="1. Mahnung" [(Date)]="ruek.mahnung" [MinDate]="Auftrag?.versand?.paketVersand"  [enabeld]="ApiUser.HatSpezialUserBerechtigung"></Date-Select>
    </div>
  </div>
  }
  @if(ShowIfIsNotNull(ruek.mahnung))
  {
  <div class="row">
    <div class="col">
      <Date-Select LabelText="2. Mahnung" [(Date)]="ruek.mahnung2" [MinDate]="Auftrag?.versand?.paketVersand" [enabeld]="ApiUser.HatSpezialUserBerechtigung"></Date-Select>
    </div>
  </div>
  }
  @if(ShowIfIsNotNull(ruek.asbAbgemeldet))
  {
  <div class="row">
    <div class="col">
      <Date-Select LabelText="Geliefert" [(Date)]="ruek.geliefert" [MinDate]="Auftrag?.versand?.paketVersand" [enabeld]="ApiUser.HatSpezialUserBerechtigung"></Date-Select>
    </div>
  </div>
  }
  @if(ShowIfIsNotNull(ruek.geliefert))
  {
  <div class="row">
    <div class="col">
      <Date-Select LabelText="Abgeschlossen" [(Date)]="ruek.abgeschlossen" [MinDate]="Auftrag?.versand?.paketVersand" [enabeld]="ApiUser.HatSpezialUserBerechtigung"></Date-Select>
    </div>
  </div>
  }
  <div class="row">
    <div class="col">
      <div class="btn btn-primary" (click)="Save()">Speichern</div>
    </div>
  </div>
  }
</div>
<ng-template #successTpl> Speichern erfolgreich! </ng-template>
